<template>
  <div id="cardcontasReceberFuturas" v-if="fetchUser && fetchUser.db.contasReceberFuturas">
    <q-card-section class="q-pb-sm">
      <div class="row items-center no-wrap">
        <div class="col">
          <div class="text-grey-9" style="font-size: 16px;">
            A Receber | Futuras
            <div class="text-bold text-grey-9" style="font-size: 22px;"
              v-if="fetchUser.db.contasReceberFuturas.total != 0">
              R$ {{ $currency(fetchUser.db.contasReceberFuturas.total) }}
            </div>
          </div>
        </div>

        <div class="col-auto">
          <router-link class="text-grey-7" :to="urlReceitas">
            <q-icon name="fa fa-external-link" size="18px" />
          </router-link>

          <q-btn color="grey-7" round flat icon="more_vert">
            <q-menu cover auto-close>
              <q-list>
                <q-item clickable @click="removerCard">
                  <q-item-section>
                    <div class="text">
                      <q-icon name="delete" /> Remover
                    </div>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </q-btn>
        </div>
      </div>
    </q-card-section>

    <q-card-section class="q-py-none">
      <q-markup-table dense flat separator="none">
        <tbody>
          <tr v-for="receita in receitas" :key="receita.id" class="cursor-pointer" @click.stop="detalhar(receita)">
            <td class="text-left">{{ $formatDate(new Date(receita.vencimento)) }}</td>
            <td>
              <span v-if="receita.cadastro">
                {{ getNomeCliente(receita.cadastro.nome) }}
                <q-tooltip v-if="receita.cadastro.nome.length >= 34">
                  {{ receita.cadastro.nome }}
                </q-tooltip>
              </span>
            </td>
            <td class="text-right">R$ {{ $currency(receita.valor) }}</td>
          </tr>
          <tr v-if="receitas.length === 0">
            <td colspan="4">Não há receitas para esta semana!</td>
          </tr>
        </tbody>
      </q-markup-table>
    </q-card-section>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "card-contas-receber-futuras",
  data() {
    return {};
  },
  methods: {
    removerCard() {
      this.$store.dispatch("trocaVisibilidadeCard", {
        cardId: "18",
      });
    },
    getNomeCliente(nome) {
      if (nome.length <= 34) {
        return nome;
      }

      return nome.substr(0, 34) + '...';
    },
    detalhar(movconta) {
      this.$store.commit("receitaQrcode", movconta.id);
      this.$store.dispatch("detalharReceitas", movconta);
    },
  },
  computed: {
    ...mapGetters(["fetchUser"]),
    receitas() {
      return this.fetchUser.db.contasReceberFuturas.receitas;
    },
    urlReceitas() {
      const { dtini, dtfim } = this.fetchUser.db.contasReceberFuturas;
      const formatedDtini = moment(dtini, "DD/MM/YYYY").format("DD-MM-YYYY");
      const formatedDtfim = moment(dtfim, "DD/MM/YYYY").format("DD-MM-YYYY");

      return `/receitas?dtini=${formatedDtini}&dtfim=${formatedDtfim}`;
    },
  },
};
</script>

<style lang="stylus" scoped>
  #cardcontasReceberFuturas
    height: 100%;
    overflow-x: auto;

  a
    text-decoration: none;
</style>
